import Vue from 'vue'
import Router from 'vue-router'

// import view function
import Home from '@/views/Home'
import About from '@/views/About'
import LogIn from '@/views/LogIn'
import Register from '@/views/Register'
import Cart from '@/views/Cart'
import CheckOut from '@/views/CheckOut'
import Offer from '@/views/Offer'
import Contact from '@/views/Contact'
import AllShop from '@/views/AllShop'
import FAQ from '@/views/FAQ'
import Computer from '@/views/Computer'
import ShopSingle from '@/views/ShopSingle'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/login',
      component: LogIn
    },
    {
      path: '/register',
      component: Register
    },
    {
      path: '/cart',
      component: Cart
    },
    {
      path: '/checkout',
      component: CheckOut
    },
    {
      path: '/offer',
      component: Offer
    },
    {
      path: '/contact',
      component: Contact
    },
    {
      path: '/shop',
      component: AllShop
    },
    {
      path: '/computer',
      component: Computer
    },
    {
      path: '/faq',
      component: FAQ
    },
    {
      path: '/product/id',
      component: ShopSingle
    }
  ]
})
